<template>
  <p :class="classString" :style="cssString" @input="updateComponent" v-html="$t(html)" ref="paragraph"></p>
</template>

<script>
import debounce from "lodash/debounce";
export default {
  name: "paragraph",
  props: {
    text: {
      type: String,
      default: "Empty paragraph"
    },
    grid: {
      type: Object,
      default: () => ({
        backgroundColor: "#fff"
      })
    },
    actions: {
      type: Array,
      default: () => {
        return  []
      }
    },
    variables: Object,
    styles: {
      type: Object,
      default: () => {
        return {};
      }
    },
    classes: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data () {
    return {
      cssString: "",
      classString:""
    };
  },
  mounted () {
    if (this.actions.length > 0) {
      this.$refs.paragraph.addEventListener('click', this.triggerActions)
      this.$refs.paragraph.addEventListener('keypress', (e) => {
        if (e.keyCode == 13) {
          e.preventDefault();
          this.triggerActions();
        }
      })
      this.$refs.paragraph.setAttribute('tabindex', 0)
    }
  },
  computed: {
    html () {
      let result = this.text;
      if (this.variables) {
        for (const variable in this.variables) {
          let value = this.$store.state.formData[variable];
          if(variable === "referenceNumber") {
            value = this.$store.getters.getReferenceNumber
          }
          result = result.replace(new RegExp(`{${variable}}`, "g"), value);
        }
      }
      return result;
    }
  },
  watch: {
    styles: {
      immediate: true,
      handler () {
        const keys = Object.keys(this.styles);
        const vals = Object.values(this.styles);
        keys.forEach((key, idx) => (this.cssString += key + ":" + vals[idx]));
      }
    },
    classes: {
      immediate: true,
      handler () {
        this.classes.forEach(cls=>{
          this.classString += cls+" ";
        })
      }
    }
  },
  methods: {
    updateComponent: debounce(function (event) {
      this.$emit("component-updated", {
        text: event.target.innerText
      });
    }, 2000),
    triggerActions () {
      if (this.actions) {
        this.actions.forEach(action => {
          const fn = action.fn;
          const params = action.params;
          this[fn](params, this);
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  outline: 0;
}

.heading {
  font-weight: 800;
  font-size: 48px;
  line-height: 60px;
  letter-spacing: 0px;
  color: var(--text-color-2);
  opacity: 1;
  margin: auto;

  &.topPadding {
    padding-top: 192px;

    @media (max-width: 575px) {
      padding-top: 60px;
    }
  }
}

.subHeading {
  font-size: 24px;
  line-height: 30px;
  letter-spacing: 0px;
  color: var(--text-color-4);
  opacity: 1;
  margin: auto;
}

.subText {
  font-size: 16px;
  line-height: 26px;
  color: #474747;
}

.loginSubText {
  text-align: center;
  text-decoration: underline;
  font: normal normal 500 20px/24px Montserrat, Medium;
  letter-spacing: 0px;
  color: #000;
  opacity: 1;
  padding: 0px;
}

.stepCard {
  margin-top: 10px;

  color: #1A1111;
  text-align: center;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0px;

  @media (max-width: 545px) {
    font-size: calc(100vw / 545 * 14 + 2px);
  }

}

@media (max-width: 991px) {

  .heading {
    font-size: 24px;
    line-height: 34px;
  }
  .subHeading {
    font-size: 16px;
    line-height: 20px;
  }

  .desktop-only {
    display: none !important;
  }
}

</style>
